import { memo } from "react";

import * as css from "./Stepper.module.css";

export interface IStepperItem {
    title?: string;
    description: string;
    svgFile: string;
}

export interface IStepperLine {
    height: string;
    width: string;
}

export interface IStepper {
    stepList: IStepperItem[];
    lineInfo: IStepperLine;
    lineColor: string;
}

const Stepper = memo(
    (props: IStepper) => (
        <div className={css.stepperComponent}>
            {props.lineInfo && (
                <svg className={css.stepsLine}>
                    <line
                        x2={props.lineInfo.width}
                        y2={props.lineInfo.height}
                        strokeWidth="4"
                        strokeDasharray="12 10"
                        stroke={props.lineColor}
                    />
                </svg>
            )}
            {props.stepList &&
                props.stepList.map((step, i) => (
                    <div className={css.stepItem} key={step.title || i}>
                        <img src={step.svgFile} alt={`stepItem ${step.title}`} />
                        {step.title && <h3 className={css.title}>{step.title}</h3>}
                        {step.description && (
                            <p
                                className={css.description}
                                dangerouslySetInnerHTML={{ __html: step.description }}
                            />
                        )}
                    </div>
                ))}
        </div>
    ),
    (prev, next) => {
        if (prev.lineInfo.height !== next.lineInfo.height || prev.stepList.length !== next.stepList.length) {
            return false;
        }
        return true;
    },
);

export default Stepper;
